export enum DataTypes {
	Unknow = 0,
	People,
	PeopleLunch,
	PeopleTime,
	OfficeUtilization,
	UtilizationTime,
	RoomUtilization,
	AvgTemperature,
	AvgHumidity,
	AvgLight,
	UtilizationPerPerson,
	ConferenceUtilization,
	MeetingsPerDay,
	AvgCO2,
	SoundAvg,
	SoundPeak,
	Motion,
	Activity,
	MinCO2,
	MaxCO2,
	MinSoundAvg,
	MaxSoundAvg,
	MinSoundPeak,
	MaxSoundPeak,
	MinMotion,
	MaxMotion,
	MinTemperature,
	MaxTemperature,
	MinHumidity,
	MaxHumidity,
	MinLight,
	MaxLight,
	PCMeetingsPerDay,
	MeetingLength,
	AvgMeetingSize,
	MaxPeople,
}

export enum NodeTypes {
	Office = 1,
	Room,
	Desk,
	Location,
	Floor,
	RoomExcluded,
	OfficeInOffice,
	Space,
	Entrance,
}

export enum UnitConversion {
	KilogramsToPounds = 2.205,
	KilogramsToMetricTonnes = 1000,
	KilogramsToImperialTons = 0.000984206528,
	SquareMetersToSquareFeet = 10.76391042,
}
